import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { AssignmentIndOutlined, ManageAccountsOutlined } from "@mui/icons-material";

import "./AccessManagementLayout.css";

const TABS = [
  { label: "Role Assignments", to: "/ecr-ops/access-management/role-assignments", icon: <AssignmentIndOutlined fontSize="small" /> },
  { label: "Roles & Permissions", to: "/ecr-ops/access-management/roles", icon: <ManageAccountsOutlined fontSize="small" /> },
];

// Shell for the Access Management screens: a sub-nav under the shared
// ecr-ops dark header bar, then a scrollable content area for the active screen.
// Permissions are loaded by RequireAccessManagementRole, the route guard that
// wraps this layout — by the time this renders, access is already confirmed.
const AccessManagementLayout = () => {
  return (
    <div>
      <nav className="am-subnav" aria-label="Access Management sections">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) => `am-subnav__link${isActive ? " active" : ""}`}
          >
            {tab.icon}
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
};

export default AccessManagementLayout;
